import { Eye, Info, PenLine, PlusCircle } from "@tamagui/lucide-icons";
import type { LearnAboutInfo } from "../LearnScreen";

export const InfoLearnMore: LearnAboutInfo[] = [
  {
    titleIcon: Info,
    title: "Information",
    subtitle: "Add readonly information about anything",
    image: require("../../../../web_legacy/static/info_card_preview.webp"),
    featureList: [
      {
        icon: PenLine,
        text: "1. Enter any information using the in-built editor",
      },
      {
        icon: PlusCircle,
        text: "2. Make sure to test out all features of the editor, you can for example add links, lists and format text",
      },
      {
        icon: Eye,
        text: "3. See a preview on the overview",
      },
    ],
    descriptions: [
      {
        icon: Info,
        title: "What is it?",
        description:
          "Keep all essential details in one place with the Information card, ensuring everyone stays informed and on the same page.",
      },
    ],
  },
];
